import React from 'react'
import { Box } from '@maui/elements'
import { Router } from './Router'

export function App() {
  return (
    <Box
      padding="spacePaddingMedium"
      flex="1"
      display="flex"
      flexDirection="column"
      color="colorTextMain"
    >
      <Router />
    </Box>
  )
}
